import { dashboardIcon } from "../../assets/img";

export const PropertyRequest = ({ isDataAllCard }) => {
  const styles = {
    label: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "13px", // smaller
      lineHeight: "18px", // smaller
      color: "#A7A7A7",
    },
    value: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "15px", // smaller
      lineHeight: "20px", // smaller
      color: "#222227",
    },
  };

  return (
    <>
      <div
        style={{
          padding: 12, // smaller
          width: "100%",
          background: "#FFFFFF",
          boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)", // slightly lighter
          borderRadius: "10px",
          height: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 16, // smaller
          }}
        >
          <p
            style={{
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "15px", // smaller
              lineHeight: "20px", // smaller
              display: "flex",
              alignItems: "center",
              color: "#222227",
            }}
          >
            Property Request
          </p>
        </div>

        <div
          style={{
            border: "1px solid #EEEEEE",
            display: "flex",
            justifyContent: "space-between",
            borderRadius: "16px", // slightly smaller
            padding: "12px 16px", // smaller
            marginTop: "12px", // smaller
          }}
        >
          <div>
            <p
              style={{
                fontSize: "15px", // smaller
                fontWeight: "400",
                color: "#9ca3af",
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "6px", // smaller
              }}
            >
              Total Request Received
            </p>

            <p
              style={{
                fontSize: "20px", // smaller
                fontWeight: "bold",
                color: "#000000",
                margin: 0,
              }}
            >
              {isDataAllCard?.property_request?.total_request_received &&
                (
                  isDataAllCard?.property_request?.total_request_received || 0
                ).toFixed(2)}
            </p>
          </div>

          <div style={{ width: "24px", height: "24px" }}>
            {" "}
            {/* smaller */}
            <img
              src={dashboardIcon}
              className="iconContainer"
              alt=""
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>

        <div>
          <p
            style={{
              marginTop: "8px", // smaller
              fontFamily: "Open Sans",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "15px", // smaller
              lineHeight: "20px",
              color: "#222227",
            }}
          >
            Total
          </p>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 4,
              justifyContent: "space-between",
              marginTop: "6px", // smaller
            }}
          >
            {/* BOX 1 */}
            <div
              style={{
                background: "#F5F5F5",
                flexDirection: "row",
                justifyContent: "space-between",
                display: "flex",
                padding: "8px", // smaller
                width: "48%",
                borderRadius: "8px", // smaller
                marginBottom: "12px", // smaller
              }}
            >
              <p style={styles.label}>Request Pending</p>
              <p style={styles.value}>
                {isDataAllCard?.property_request?.request_pending &&
                  (
                    isDataAllCard?.property_request?.request_pending || 0
                  ).toFixed(2)}
              </p>
            </div>

            {/* BOX 2 */}
            <div
              style={{
                background: "#F5F5F5",
                flexDirection: "row",
                justifyContent: "space-between",
                display: "flex",
                padding: "8px",
                width: "48%",
                borderRadius: "8px",
                marginBottom: "12px",
              }}
            >
              <p style={styles.label}>Request Accepted</p>
              <p style={styles.value}>
                {isDataAllCard?.property_request?.request_accepted &&
                  (
                    isDataAllCard?.property_request?.request_accepted || 0
                  ).toFixed(2)}
              </p>
            </div>

            {/* BOX 3 */}
            <div
              style={{
                background: "#F5F5F5",
                flexDirection: "row",
                justifyContent: "space-between",
                display: "flex",
                padding: "8px",
                width: "48%",
                borderRadius: "8px",
                marginBottom: "12px",
              }}
            >
              <p style={styles.label}>Request Rejected</p>
              <p style={styles.value}>
                {isDataAllCard?.property_request?.request_rejected &&
                  (
                    isDataAllCard?.property_request?.request_rejected || 0
                  ).toFixed(2)}
              </p>
            </div>

            {/* BOX 4 */}
            <div
              style={{
                background: "#F5F5F5",
                flexDirection: "row",
                justifyContent: "space-between",
                display: "flex",
                padding: "8px",
                width: "48%",
                borderRadius: "8px",
                marginBottom: "12px",
              }}
            >
              <p style={styles.label}>MMC Pending for Live</p>
              <p style={styles.value}>
                {isDataAllCard?.property_request?.mmc_pending_for_live &&
                  (
                    isDataAllCard?.property_request?.mmc_pending_for_live || 0
                  ).toFixed(2)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
